import React, { useState, createContext, useContext } from 'react';
import Sidebar from './Sidebar';
import { SidebarTrigger } from './ui/sidebar-trigger';

const LayoutContext = createContext();

export const useLayoutContext = () => useContext(LayoutContext);

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved === 'true';
  });
  const [title, setTitle] = useState(null);
  const [rightContent, setRightContent] = useState(null);

  const handleCollapseChange = (newCollapsed) => {
    setCollapsed(newCollapsed);
    localStorage.setItem('sidebarCollapsed', newCollapsed.toString());
  };

  const value = { collapsed, setCollapsed: handleCollapseChange, setTitle, setRightContent };

  return (
    <div className="min-h-screen bg-background flex">
      <Sidebar onCollapseChange={handleCollapseChange} collapsed={collapsed} />
      <div className={`flex-1 transition-all duration-300 relative ${
        collapsed ? 'ml-20' : 'ml-56'
      }`}>
        <div className="container mx-auto px-6 py-8 relative">
          <div className="flex items-center gap-4 mb-6">
            {title && <div className="flex-1">{title}</div>}
            {rightContent && <div>{rightContent}</div>}
          </div>
          <LayoutContext.Provider value={value}>
            {children}
          </LayoutContext.Provider>
        </div>
      </div>
    </div>
  );
};

export default Layout;